export default "__VITE_ASSET__M6W2DRn8__"